
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.video-wrapper{aspect-ratio:16/9;border-radius:.25em;border-radius:var(--video-embed-bdrs,.25em);position:relative}button{align-items:center;background:transparent;border:none;cursor:pointer;display:flex;flex-direction:column;inset:0;justify-content:center;overflow:hidden;position:absolute}button svg{fill:var(--outline-white);filter:drop-shadow(5px 5px 10px rgba(0,0,0,.2))}button svg .play,button:hover svg{fill:var(--brand-primary)}button:hover svg .play{fill:var(--outline-white)}button:focus svg{border-radius:50%;outline:var(--outline-white) dashed 2px;outline-offset:2px}:is(iframe,img){block-size:100%;border:0;border-radius:inherit;inline-size:100%;inset:0;object-fit:cover;position:absolute}iframe:not([src=""])+button{display:none}[slot=video-summary]{color:var(--color-font-content);font-family:var(--ff-body);font-size:var(--fs-sm);line-height:var(--lh-base);padding-block:var(--spacing-2)}`;